import { useState, useEffect } from 'react';
import { isSSR } from '../scripts/utils';

export function getWindowDimensions() {
  if (typeof document === 'undefined') {
    // SSR 时返回默认值
    return {
      width: 1920,
      height: 1080
    };
  }
  
  let { clientWidth: width, clientHeight: height } = document.body;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(() => {
    // 在hydration期间，使用与SSR相同的默认值，避免hydration不匹配
    if (isSSR) {
      return getWindowDimensions();
    }
    // 客户端首次渲染时也使用默认值，然后在useEffect中更新
    return { width: 1920, height: 1080 };
  });

  useEffect(() => {
    if (isSSR) return;

    // 在客户端hydration完成后，更新为实际尺寸
    setWindowDimensions(getWindowDimensions());

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
